const apiUrls = require('../../constants/apiUrls');

const charges = {
    key: 'charges',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.CHARGE_OPTIONS_URL}?jobNumber=${request.workOrderNumber}&accountNumber=${request.accountNumber}&billingSystem=${request.billingSystem}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }, {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }, {
            key: 'customerDetails',
            requestProps: [
                {
                    path: [
                        'details', 'dwellingType'
                    ],
                    propName: 'dwellingType'
                }
            ]
        }
    ]
};

export default charges;


// WEBPACK FOOTER //
// ./src/store/order-details-config/charges.js